import React from 'react';
import Disc_Lf_Date from './Disc_Lf_Date';
import '../../../CommonCSS/SocietyCSS.css'

const DiscLFDateApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Discount And Late Fee</h5>
          </div>
        </div>
        <Disc_Lf_Date/>
      </div>
    </div >
  );
};

export default DiscLFDateApp;
